import { Component, Input } from '@angular/core';
import { LossPayroll } from '../../../shared';

@Component({
    selector: 'my-loss-payroll',
    styles: [require('./loss-payroll.component.scss')],
    template: require('./loss-payroll.component.pug')
})
export class LossPayrollComponent {
    @Input() lossPayrolls: Array<LossPayroll>;
    @Input() totalLossPayroll: number;

    constructor() { }

    // private GetTotal(): number {
    //     let totalPayrolls = 0;

    //     this.lossPayrolls.forEach(element => {

    //         totalPayrolls += element.salary;
    //     });

    //     return totalPayrolls;
    // }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/profit-loss/loss/loss-payroll/loss-payroll.component.ts